import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {DialogInterface} from '../../utils/confirmation-dialog/confirmation-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BeneficiariesService} from '../beneficiaries.service';
import {Router} from '@angular/router';
import {DashboardService} from '../../../dashboard.service';
import {AppTitleService} from '../../../app-title.service';
import {encrypt, mobile} from '../../../consts/utilities';
import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {MatBottomSheet} from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-beneficiaries-create',
    templateUrl: './beneficiaries-create.component.html',
    styleUrls: ['./beneficiaries-create.component.scss']
})
export class BeneficiariesCreateComponent implements OnInit {
    // public selectedCard: number = null;
    // public showHelp: boolean;
    // private dialogInterface: DialogInterface;
    // public dialogAccess: MatDialogRef<any>;
    public dialogConf: MatDialogRef<any>;
    @ViewChild('personalDataDialog', {static: true}) private personalDataDialog: TemplateRef<any>;
    @ViewChild('inputName') private inputName: ElementRef<HTMLInputElement>;
    @ViewChild('cardSearchInput') private inputCardSearch: ElementRef<
        HTMLInputElement
    >;
    // public typeOfCards: {
    //     title?: string;
    //     description?: string;
    //     src?: string;
    //     backgroundImage?: string;
    //     caption?: string;
    //     thumb?: string;
    // }[] = [
    //     {
    //         title: 'Vales',
    //         description: 'Tarjeta de vales vía nomina',
    //         src: 'assets/img/tarjeta-de-vales-calimax.png',
    //         backgroundImage: 'assets/img/cards/despensa_electronica_Calimax.jpg'
    //     },
    //     {
    //         title: 'Monedero',
    //         description: 'Obten descuento y acumula monedero',
    //         src: 'assets/img/tarjeta-de-vales-calimax.png',
    //         backgroundImage: 'assets/img/cards/monedero_electronico.jpg'
    //     },
    //     {
    //         title: 'Regalo',
    //         description: 'Para compras generales',
    //         src: 'assets/img/tarjeta-regalo-calimax.png',
    //         backgroundImage: 'assets/img/cards/tarjeta_de_regalo.jpg'
    //     },
    //     {
    //         title: 'Club',
    //         description: 'Obtiene descuentos y acumula puntos',
    //         src: 'assets/img/tarjeta-regalo-calimax.png',
    //         backgroundImage: 'assets/img/cards/tarjeta_de_regalo_2.jpg'
    //     }
    // ];
    // public spWrapper: any = {
    //     funcion: 'sp_js_100',
    //     param_in: {
    //         action: null,
    //         materno: null,
    //         paterno: null,
    //         papp: null,
    //         cardno: null,
    //         curp: null,
    //         domicilio: null,
    //         fecha_nac: null,
    //         pip: null,
    //         id_ident: null,
    //         num_ident: null,
    //         id_sesion: null,
    //         id_usu: null,
    //         nombre: null,
    //         pais_nac: null,
    //         rfc: null,
    //         pso: null,
    //         telefono: null
    //     },
    //     action: null,
    //     cardno: null,
    //     param_out: []
    // };

    // public sp100Out: any[] = [];
    // public sp100Input: any;
    public inputObject: {
        state?: number;
        value?: string;
        disabled?: boolean;
        icon?: string;
    } = {
        value: '',
        disabled: false,
        state: 0,
        icon: 'search'
    };
    public cardSearchForm = new FormGroup({
        cardSearchInput: new FormControl('', [
            Validators.pattern(/^[0-9+-]*$/),
            Validators.required
        ])
    });

    public bPersonalData = this.fb.group({
        nombre: [
            null,
            [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(
                    /^[a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ, ' ']*$/
                )
            ]
        ],
        apellido_p: [
            null,
            [
                Validators.required,
                Validators.minLength(2),
                Validators.pattern(
                    /^[a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ, ' ']*$/
                )
            ]
        ],
        apellido_m: [
            null,
            [
                Validators.pattern(
                    /^[a-z,A-Z,á,é,í,ó,ú,â,ê,ô,ã,õ,ç,Á,É,Í,Ó,Ú,Â,Ê,Ô,Ã,Õ,Ç,ü,ñ,Ü,Ñ, ' ']*$/
                ),
                Validators.minLength(2)
            ]
        ],
        telefono: ['', [Validators.maxLength(10), Validators.minLength(10)]]
    });

    @ViewChild('existingCard', { static: true })
    existingCard: TemplateRef<any>;

    @ViewChild('invalidCard', { static: true })
    invalidCard: TemplateRef<any>;

    @ViewChild('maximumReached', { static: true })
    maximumReached: TemplateRef<any>;

    public badReqMessage = '';
    public unEntityMessage = '';
    public cfMessage = '';

    constructor(
        private beneficiariesService: BeneficiariesService,
        private snackbar: MatSnackBar,
        private bottomSheet: MatBottomSheet,
        private dialog: MatDialog,
        private fb: FormBuilder,
        private router: Router,
        private dashboard: DashboardService,
        private titleService: AppTitleService,
    ) {}

    ngOnInit(): void {
        this.titleService.setTitle('Nuevo beneficiario');
        this.onChanges();
    }

    private onChanges(): void {
        this.cardSearchForm.valueChanges.subscribe((val: { cardSearchInput }) => {
            this.onValueChange(val.cardSearchInput);
        });
    }

    private onValueChange(value: string): void {
        this.inputObject.value = value;
        if (this.inputObject.value.length < 1) {
            this.iconInputState(1);
        } else if (this.inputObject.value.length > 0) {
            this.iconInputState(2);
        }
    }

    private requestPersonalData(): void {
        this.dialogConf = this.dialog.open(this.personalDataDialog, {
            width: '400px'
        });
        this.dialogConf.afterOpened().subscribe(() => {
            setTimeout(() => {
                this.inputName.nativeElement.focus();
            }, 100);
        });
        this.dialogConf.afterClosed().subscribe(() => {
            this.cardSearchForm.get(['cardSearchInput']).setValue('');
        });
    }

    private checkBeneficiary(): void {
        const cardNumber = this.cardSearchForm.get(['cardSearchInput']).value;
        const encryptedNumber = encrypt(cardNumber);

        this.beneficiariesService.getBeneficiaries(encryptedNumber).subscribe(
            val => {
                const { statusCode, data } = val;

                if (statusCode !== HttpStatusCode.Ok) {
                    // Notify error
                    return;
                }
            },
            (error: HttpErrorResponse) => {
                const { error: ex } = error;
                const { statusCode, message } = ex;

                this.badReqMessage = message;

                if (statusCode === HttpStatusCode.BadRequest) {
                    // Notify error
                    if (mobile()) {
                        this.bottomSheet.open(this.invalidCard);
                    }

                    if (!mobile()) {
                        this.dialog.open(this.invalidCard);
                    }
                }
            }
        );
    }

    public insertBeneficiaries() {
        if (this.bPersonalData.valid === true) {
            this.dialogConf.close();
            this.dialogConf.afterClosed().subscribe(value => {
                this.cardSearchForm.get(['cardSearchInput']).setValue('');
            });

            // this.iconInputState(3);

            const pCardNo = this.cardSearchForm.get(['cardSearchInput']).value;
            const pNombre = this.bPersonalData.get(['nombre']).value;
            const pApellidoP = this.bPersonalData.get(['apellido_p']).value;
            const pApellidoM = this.bPersonalData.get(['apellido_m']).value;
            // const pTelefono = this.bPersonalData.get(['telefono']).value;

            const payload = {
                cardno: encrypt(pCardNo),
                nombre: pNombre,
                ap_paterno: pApellidoP,
                ap_materno: pApellidoM,
            };
            this.beneficiariesService.addBeneficiary(payload).subscribe(
                response => {
                    const { statusCode, data } = response;

                    if (statusCode !== HttpStatusCode.Ok) {
                        return;
                    }

                    this.router.navigate(['/app/beneficiaries']);
                },
                (error: HttpErrorResponse) => {
                    const { error: ex } = error;
                    const { statusCode, message } = ex;

                    if (statusCode === HttpStatusCode.BadRequest) {
                        this.badReqMessage = message;

                        if (mobile()) {
                            this.bottomSheet.open(this.invalidCard);
                        }

                        if (!mobile()) {
                            this.dialog.open(this.invalidCard);
                        }
                    }

                    if (statusCode === HttpStatusCode.Conflict) {
                        this.cfMessage = message;

                        if (mobile()) {
                            this.bottomSheet.open(this.existingCard);
                        }

                        if (!mobile()) {
                            this.dialog.open(this.existingCard);
                        }
                    }

                    if (statusCode === HttpStatusCode.UnprocessableEntity) {
                        this.unEntityMessage = message;

                        if (mobile()) {
                            this.bottomSheet.open(this.maximumReached);
                        }

                        if (!mobile()) {
                            this.dialog.open(this.maximumReached);
                        }
                    }
                }
            );
        } else {
            this.snackbar
                .open('Completa los datos necesarios.', 'Aceptar', {
                    duration: 5000,
                    verticalPosition: 'top'
                })
                .onAction()
                .subscribe(() => {
                    this.inputName.nativeElement.focus();
                });
        }
    }

    // public clearInput() {
    //     this.iconInputState(1);
    //     // this.setFetchedFormValues();
    //     this.cardSearchForm.get(['cardSearchInput']).setValue('');
    //     // this.inputObject.icon =
    // }

    private iconInputState(stateNumber: number) {
        switch (stateNumber) {
            case 1:
                this.inputObject.state = stateNumber;
                this.inputObject.icon = 'clear';
                break;
            case 2:
                this.inputObject.state = stateNumber;
                this.inputObject.icon = 'search';
                break;
            case 3:
                this.inputObject.state = stateNumber;
                this.inputObject.icon = 'hourglass_empty';
                break;
            case 4:
                this.inputObject.state = stateNumber;
                this.inputObject.icon = 'clear';
                break;
        }
    }

    public inputBeneficiariesActions() {
        if (this.cardSearchForm.valid) {
            this.requestPersonalData();
        }
    }

    public dismiss(): void {
        if (mobile()) {
            this.bottomSheet.dismiss();
        }

        if (!mobile()) {
            this.dialog.closeAll();
        }
    }

    // public showHelpFn() {
    //     this.showHelp = this.showHelp ? false : true;
    // }

    // public onSelectedCard(index: number): void {
    //     if (this.selectedCard === null) {
    //         this.selectedCard = index;
    //     } else if (this.selectedCard !== index) {
    //         this.selectedCard = index;
    //     } else {
    //         this.selectedCard = null;
    //     }
    // }
}
